import type { Organization, OrganizationMember, OrganizationRole } from '../types';

export interface ApiOrganization {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  logoUrl: string | null;
  website: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
  settings?: Record<string, unknown> | null;
  role?: OrganizationRole;
  memberCount?: number;
  productCount?: number;
}

export interface ApiOrganizationMember {
  id: string;
  organizationId?: string;
  userId: string;
  role: OrganizationRole;
  joinedAt: string;
  invitedBy?: string | null;
  user?: OrganizationMember['user'];
}

export function transformOrganization(organization: ApiOrganization): Organization {
  return {
    id: organization.id,
    name: organization.name,
    slug: organization.slug,
    description: organization.description,
    logo_url: organization.logoUrl,
    website: organization.website,
    is_active: organization.isActive,
    created_at: organization.createdAt,
    updated_at: organization.updatedAt ?? organization.createdAt,
    settings: organization.settings ?? null,
    role: organization.role,
    member_count: organization.memberCount,
    product_count: organization.productCount,
  };
}

export function transformOrganizationMember(
  member: ApiOrganizationMember,
  organizationId: string
): OrganizationMember {
  return {
    id: member.id,
    organization_id: member.organizationId ?? organizationId,
    user_id: member.userId,
    role: member.role,
    joined_at: member.joinedAt,
    invited_by: member.invitedBy ?? null,
    user: member.user,
  };
}
